import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { octoberGalleryMedia } from "../../data/octoberGalleryMedia";
import { octoberBrandMedia } from "../../data/octoberBrandMedia";
import { firm } from "../../data/site";
import { SiteLink } from "../SiteLink";
const cards = [{
  id: "answers",
  title: "Common motorcycle crash questions",
  copy: "What should I do after a motorcycle crash? Start with safety and medical care. Then learn what information to save.",
  label: "First steps after a crash",
  path: "/rider-resources/michigan-motorcycle-crash-first-24-hours/",
  image: octoberGalleryMedia.training
}, {
  id: "free-resources",
  title: "FREE resources for Michigan riders",
  copy: "Understand motorcycle insurance, no-fault benefits and injury claims with the firm’s practical guides.",
  label: "Explore the insurance guide",
  path: "/michigan-motorcycle-law-insurance-guide/",
  image: octoberGalleryMedia.speaking
}, {
  id: "community",
  title: "Giving back to the motorcycle community",
  copy: "A portion of the firm’s legal fees supports motorcycle awareness, bystander assistance and rider education programs.",
  label: "See how the firm gives back",
  path: "/helping-the-biker-community/",
  image: octoberGalleryMedia.awareness
}, {
  id: "riding-events",
  title: "Michigan motorcycle events",
  copy: "Find rides, rallies and bike nights across Michigan. Explore the event calendar and photos from the riding community.",
  label: "Explore events and photos",
  path: "/events/",
  image: octoberGalleryMedia.community
}, {
  id: "meet-team",
  title: "Meet the team",
  copy: `Meet the attorneys who work with ${firm.displayName} to represent injured riders and their families.`,
  label: "Get to know the legal team",
  path: "/about-us/",
  image: octoberBrandMedia.portrait
}];
export function ResourceGallery() {
  return <section aria-labelledby="resource-gallery-title" className="resource-gallery" data-id="element-257" data-mp="9ey6nzqfofjs">
    <div className="page-container resource-gallery-inner" data-id="element-258" data-mp="deyolucqr8vl">
      <p className="eyebrow text-crimson" data-id="element-259" data-mp="dhbd6qd08hhm">For the road ahead</p>
      <h2 id="resource-gallery-title" className="section-title" data-id="element-260" data-mp="1gr739s838ghx">Resources, people and community.</h2>
      <div className="image-resource-grid" data-id="element-261" data-mp="1bsm9obnccv2g">
        {cards.map(card => <SiteLink key={card.id} path={card.path} className="image-resource-card" data-id="element-262" data-mp="1prlpctsvlzmh">
          <img src={card.image.src} srcSet={card.image.srcSet} sizes="(min-width:1024px) 480px, (min-width:640px) 50vw, 100vw" width={card.image.width} height={card.image.height} alt="" loading="lazy" decoding="async" data-id="element-263" data-mp="1lpibxzmnckyk" />
          <div className="image-resource-copy" id={card.id} data-id="element-264" data-mp="1uqowcjsf2fx3">
            <h3 data-id="element-265" data-mp="1uocfyb2b4dm5">{card.title}</h3>
            <p data-id="element-266" data-mp="29fkyy1bpf0qb">{card.copy}</p>
            <span className="image-resource-link" data-id="element-267" data-mp="29drtuqgqookf">{card.label} <ArrowRightIcon size={21} aria-hidden="true" data-id="element-268" data-mp="24fzytnkssmc0" /></span>
          </div>
        </SiteLink>)}
      </div>
    </div>
  </section>;
}